module.exports = __webpack_public_path__ + "img/subjective-detection_highlight.e73458bc.svg";